import { Loading } from "element-ui";
import req from "./https";

// 全域 api 掛載於 Vue.prototype
// 使用方式 this.$api
// api 命名原則 首字大寫爾後駝峰
const api = {
  /* Banner */
  banner() {
    return req("get", "banners/loadClient");
  },
  /* 最新消息 */
  news(params) {
    return req("get", "newss/loadClient", params);
  },
  /* 教學設備與空間 */
  classrooms(params) {
    return req("get", "classrooms/load", params);
  },
  getclassrooms(params) {
    return req("get", "classrooms/get", params);
  },
  classroomPics(params) {
    return req("get", "classroomPics/loadByRoomId", params);
  },
  /* 五大工坊 */
  crafts(params) {
    return req("get", "workshopDatas/load", params);
  },
  /* 系所規定與申請表 */
  departmentRule(params) {
    return req("get", "departmentRules/loadClient", params);
  },
  /* 競賽得獎、研究發表、交換生專區 */
  award(params) {
    return req("get", "departmentteachs/load", params);
  },
  memberDatas(params) {
    return req("get", "departmentMemberDatas/load", params);
  },
  /* 展覽紀錄、活動花絮 */
  record(params) {
    return req("get", "departmentActivityAlbums/load", params);
  },
  departmentAlbemPics(params) {
    return req("get", "departmentAlbemPics/loadByAlbumId", params);
  },
  /* 研討會&工作營 */
  seminarNews(params) {
    return req("get", "seminarNewss/loadClient", params);
  },
  seminarWorks(params) {
    return req("get", "seminarWorks/get", params);
  },
  /* 系所成員 */
  members(params) {
    return req("get", "departmentMembers/load", params);
  },
  /* 畢業生動態 */
  alumni(params) {
    return req("get", "departmentAlumnis/loadClient", params);
  },
  /* 招生連結 */
  relatedlink(params) {
    return req("get", "relatedLinks/load", params);
  },
  /* 學分表 */
  singleFile(params) {
    return req("get", "singleFiles/load", params);
  },

  /*畢展 banner */
  getGraduateBanner() {
    return req("get", "GraduateBanners/LoadClient");
  },

  //前台列表
  getGraduateList(params) {
    return req("get", "graduate/LoadClient", params);
  },

  // 單筆
  getUnitGraduate(params) {
    return req("get", "graduate/Get", params);
  },

  //前台畢展列表
  getGraduateExhibit(params) {
    return req("get", "graduateExhibitions/LoadClient", params);
  },

  // 單筆
  getUnitExhibit(params) {
    return req("get", "graduateExhibitions/Get", params);
  },

  //前台畢展隨機列表
  getOtherList(params) {
    return req("get", "graduateExhibitions/GetOther", params);
  },

  // 前台組別
  getGroupTypeList() {
    return req("get", "graduateExhibitions/GroupTypeList");
  },
  // 單頁資訊(歷史沿革 history、學制概況 education)
  getSinglePage(params) {
    return req("get", "singlePages/Get", params);
  },
  // 系教育目標與能力綱目 列表
  getEducationCatalogsList(params) {
    return req("get", "EducationCatalogs/PublicLoad", params);
  },
  // 獲取 類別 列表
  getCategorysList(params) {
    return req("get", "Categorys/PublicLoad", params);
  },
};

export default api;
